export const rxActionType = {
    SET_TOTAL_RXS: 'SET_TOTAL_RXS',
    SET_TODAY_RXS: 'SET_TODAY_RXS',
    SET_THISWEEK_RXS: 'SET_THISWEEK_RXS',
    SET_PATIENTS_RX_COUNT: 'SET_PATIENTS_RX_COUNT',
    SET_DOCTORS_RX_COUNT: 'SET_DOCTORS_RX_COUNT',
}